module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f3b7.7a17610e.svg";